import { render } from "./Letter.vue?vue&type=template&id=ba2f521c&scoped=true"
import script from "./Letter.vue?vue&type=script&lang=js"
export * from "./Letter.vue?vue&type=script&lang=js"

import "./Letter.vue?vue&type=style&index=0&id=ba2f521c&scoped=true&lang=css"

import exportComponent from "/Users/alexmeister/Documents/minigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba2f521c"]])

export default __exports__